
  import React from "react"
  import Component from "/home/bojan/www/preset/preset/website/src/layouts/index.js"
  import data from "/home/bojan/www/preset/preset/website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js